const translations = {
  is: {
    // Rafræn undirskrift ráðningarsamnings (atvinnurekandi)
    'contract_signature.title': 'Undirritun atvinnurekanda',
    'contract_signature.full_name': 'Fullt nafn undirritanda',
    'contract_signature.preview': 'Undirskrift þín',
    'contract_signature.confirm': 'Ég staðfesti að ég sé undirritandi þessa ráðningarsamnings og samþykki efni hans fyrir hönd atvinnurekanda.',
    'contract_signature.sign_and_send': 'Undirrita og senda',
    'contract_signature.signing': 'Undirrita og sendi...',
    'contract_signature.cancel': 'Hætta við',
    'contract_signature.signed_by_employer': 'Undirritað f.h. atvinnurekanda',
    'contract_signature.signature_invalidated': 'Undirskrift fallin úr gildi',
    'contract_signature.document_changed': 'Samningnum var breytt eftir undirritun – undirskriftin er fallin úr gildi. Undirritaðu aftur.',
    'contract_signature.name_differs_warning': 'Nafnið sem þú slóst inn er frábrugðið nafni innskráðs notanda. Viltu halda áfram?',
    'contract_signature.typed_hint': 'Undirskriftin er vélrituð – skrifaðu fullt nafn þitt og það birtist sem rafræn undirskrift.',
    // Admin yfirlit (dashboard)
    'dashboard.title': 'Yfirlit',
    'dashboard.refresh': 'Endurnýja',
    'dashboard.present_now': 'Mættir núna',
    'dashboard.not_arrived': 'Ekki mættir',
    'dashboard.sick_today': 'Veikir í dag',
    'dashboard.on_leave': 'Í fríi / fjarveru',
    'dashboard.pending_requests': 'Biðandi beiðnir',
    'dashboard.needs_review': 'Þarf yfirferð',
    'dashboard.today_status': 'Staðan í dag',
    'dashboard.action_required': 'Þarf að bregðast við',
    'dashboard.next_7_days': 'Næstu 7 dagar',
    'dashboard.employee': 'Starfsmaður',
    'dashboard.shift': 'Áætluð vakt',
    'dashboard.status': 'Staða',
    'dashboard.arrival': 'Mæting',
    'dashboard.worked_so_far': 'Unnið hingað til',
    'dashboard.open': 'Opna',
    'dashboard.clear_filter': 'Hreinsa síu',
    'dashboard.no_employees': 'Engir starfsmenn í þessari síu.',
    'dashboard.no_pending': 'Engar beiðnir bíða afgreiðslu.',
    'dashboard.view_all_requests': 'Skoða allar beiðnir',
    'dashboard.quick_actions': 'Flýtiaðgerðir',
    'dashboard.register_absence': 'Skrá fjarveru',
    'dashboard.view_requests': 'Skoða beiðnir',
    'dashboard.open_timesheet': 'Opna tímaskrá',
    'dashboard.open_calendar': 'Opna dagatal',
    'dashboard.no_absences': 'Engin fjarvist',
    'dashboard.scheduled_short': 'á vakt',
    'dashboard.expected_at': 'Átti að mæta',
    'dashboard.no_clock_in': 'Ekki stimplaður inn',
    'dashboard.no_absence_registered': 'Engin fjarvera skráð',
    'dashboard.missing_clock_out': 'Vantar útstimplun',
    'dashboard.overlapping_entries': 'Skarast/tvíteknar stimplanir',
    'dashboard.unanswered_notification': 'Ósvöruð tilkynning',
    'dashboard.notification_no_answer': 'Svar: ekkert',
    'dashboard.mark_resolved': 'Merkja afgreitt',
    'dashboard.see_history': 'Sjá sögu',
    'dashboard.last_notification': 'Síðasta tilkynning',
    'dashboard.older_cases': 'eldri mál',
    'dashboard.case_unexplained': 'Óútskýrð fjarvera',
    'dashboard.resolve_reason_label': 'Ástæða (nauðsynleg)',
    'dashboard.resolve_reason_placeholder': 'T.d. Gamalt mál – afgreitt handvirkt',
    'dashboard.resolve_dialog_title': 'Merkja mætingarmál afgreitt',
    'dashboard.resolve_dialog_desc': 'Lokar málinu án þess að skrá fjarveru eða stimplun. Sagan varðveitist og aðgerðin fer í aðgerðaskrá.',
    'dashboard.history_title': 'Saga mætingarmála',
    'dashboard.history_cases': 'Mætingarmál',
    'dashboard.history_notifications': 'Sendar tilkynningar',
    'dashboard.no_history': 'Engin saga til',
    'dashboard.resolved_label': 'Afgreitt',
    'dashboard.unresolved_label': 'Óafgreitt',
    'dashboard.cancel': 'Hætta við',
    'dashboard.status_present': 'Mættur',
    'dashboard.status_not_arrived': 'Ekki mættur',
    'dashboard.status_sick': 'Veikur',
    'dashboard.status_vacation': 'Orlof',
    'dashboard.status_other_absence': 'Önnur fjarvera',
    'dashboard.status_pending_absence': 'Beiðni bíður samþykktar',
    'dashboard.status_not_started': 'Vakt ekki byrjuð',
    'dashboard.status_finished': 'Stimplaður út',
    'dashboard.status_off_today': 'Ekki á vakt í dag',
    // General
    loading: 'Hleð...',
    logout: 'Útskrá',

    // Navigation
    nav_dashboard: 'Yfirlit',
    nav_employees: 'Starfsmenn',
    nav_timesheet: 'Tímaskrá',
    nav_calendar: 'Dagatal',
    nav_leave: 'Frí og veikindi',
    nav_users: 'Notendaumsjón',
    nav_kiosk: 'Stimpilklukka',
    nav_settings: 'Stillingar',

    // Timesheet
    timesheet_title: 'Tímaskrá',
    timesheet_new_entry: 'Ný tímaskráning',
    timesheet_refresh: 'Uppfæra',
    timesheet_export_excel: 'Sækja Excel',
    timesheet_filter_employees: 'Sía eftir starfsmönnum:',
    timesheet_filter_status: 'Sía eftir stöðu:',
    timesheet_filter_status_all: 'Allt',
    timesheet_filter_status_pending: 'Í bið',
    timesheet_filter_status_approved: 'Samþykkt',
    timesheet_filter_status_rejected: 'Hafnað',
    timesheet_status_pending: 'Í bið',
    timesheet_status_approved: 'Samþykkt',
    timesheet_status_rejected: 'Hafnað',
    timesheet_approve_selected: 'Samþykkja valdar',
    timesheet_approve_single: 'Samþykkja',
    timesheet_selected_count: 'Valdar færslur',
    timesheet_filter_employees_active_button: 'Virkir starfsmenn',
    timesheet_filter_employees_inactive_button: 'Óvirkir starfsmenn',
    timesheet_filter_employees_all_button: 'Allir starfsmenn',
    timesheet_employee_label: 'Starfsmaður:',
    timesheet_employee_option_active: 'Virkir',
    timesheet_employee_optgroup_active: 'Virkir starfsmenn',
    timesheet_employee_optgroup_inactive: 'Óvirkir starfsmenn',
    timesheet_period_label: 'Tímabil:',
    timesheet_period_from_label: 'Frá:',
    timesheet_period_to_label: 'Til:',
    timesheet_period_clear: 'Hreinsa tímabil',
    timesheet_period_current: 'Núverandi launatímabil',
    timesheet_period_previous: 'Fyrra launatímabil',
    timesheet_field_clock_in_label: 'Stimpluð inn',
    timesheet_field_clock_out_label: 'Stimpluð út',
    timesheet_field_total_hours_label: 'Heildarstundir',
    timesheet_field_location_label: 'Staðsetning',
    timesheet_in_progress_value: 'Í vinnu',
    timesheet_no_location_value: 'Engin',
    timesheet_show_map: 'Skoða kort',
    timesheet_hide_map: 'Fela kort',
    timesheet_dialog_new_title: 'Ný tímaskráning',
    timesheet_dialog_edit_title: 'Breyta tímaskráningu',
    timesheet_dialog_employee_label: 'Starfsmaður',
    timesheet_dialog_clock_in_label: 'Stimpluð inn',
    timesheet_dialog_clock_out_label: 'Stimpluð út',
    timesheet_dialog_clock_out_help_new: 'Skildu eftir tómt ef ekki á að skrá út.',
    timesheet_dialog_clock_out_help_edit:
      'Skildu eftir tómt ef ekki búið að stimpla út',

    // Leave / Frí & veikindi
    leave_title: 'Frí & Veikindi',
    leave_subtitle: 'Sækja og samþykkja frí- og veikindabeiðnir',
    leave_new_request: 'Ný beiðni',
    leave_type_label: 'Tegund',
    leave_from_label: 'Frá degi',
    leave_to_label: 'Til dags',
    leave_reason_label: 'Ástæða',
    leave_status_label: 'Staða',
    leave_employee_label: 'Starfsmaður',
    leave_fetch_error: 'Villa við að sækja beiðnir',
    leave_request_sent: 'Beiðni send!',
    leave_generic_error: 'Villa kom upp',
    leave_approved: 'Beiðni samþykkt',
    leave_rejected: 'Beiðni hafnað',
    leave_request_updated: 'Beiðni uppfærð',
    leave_request_deleted: 'Beiðni eytt',
    leave_dialog_title: 'Ný beiðni um frí eða veikindi',
    leave_employee_select_placeholder: 'Veldu starfsmann',
    leave_type_option_vacation: 'Orlof',
    leave_type_option_sick: 'Veikindi',
    leave_type_option_unpaid: 'Ógreidd fjarvist',
    attendance_missing_title: 'Mæting ekki skráð',
    attendance_missing_description: 'Þú áttir að mæta til vinnu kl. {time} en engin innstimplun eða fjarvera er skráð. Hvað á við?',
    attendance_missing_sick: 'Ég er veik/ur',
    attendance_missing_vacation: 'Ég er í fríi',
    attendance_missing_other: 'Önnur fjarvera',
    attendance_missing_forgot_clock_in: 'Ég mætti en gleymdi að stimpla mig inn',
    attendance_missing_sick_multi_day: 'Veikindi í fleiri daga',
    attendance_missing_sick_end_date: 'Áætlaður lokadagur (valfrjálst)',
    attendance_missing_sick_end_date_hint: 'Skildu eftir autt ef þú veist ekki lokadaginn.',
    attendance_missing_explanation_label: 'Stutt skýring',
    attendance_missing_explanation_placeholder: 'Lýstu fjarverunni í stuttu máli...',
    attendance_missing_arrival_time_label: 'Hvenær mættir þú?',
    attendance_missing_submit: 'Senda',
    attendance_missing_back: 'Til baka',
    attendance_missing_confirmation_sick: 'Veikindi hafa verið skráð. Yfirmaður hefur verið látinn vita.',
    attendance_missing_confirmation_vacation: 'Orlofsbeiðni hefur verið send og bíður samþykktar stjórnanda.',
    attendance_missing_confirmation_other: 'Fjarveran hefur verið skráð og bíður yfirferðar stjórnanda.',
    attendance_missing_correction_requested: 'Beiðni um leiðréttingu á innstimplun hefur verið send og bíður samþykktar.',
    attendance_missing_already_answered: 'Þú hefur þegar svarað þessari tilkynningu. Takk fyrir!',
    attendance_missing_invalid_link: 'Þessi hlekkur er ógildur.',
    attendance_missing_expired_link: 'Þessi hlekkur er útrunninn. Hafðu samband við yfirmann.',
    attendance_missing_error_generic: 'Villa kom upp. Reyndu aftur eða hafðu samband við yfirmann.',
    leave_submit_button: 'Senda beiðni',

    // Common buttons
    btn_save: 'Vista',
    btn_cancel: 'Hætta við',
    btn_delete: 'Eyða',
    btn_edit: 'Breyta',
  },
  en: {
    // Electronic contract signature (employer)
    'contract_signature.title': 'Employer signature',
    'contract_signature.full_name': 'Full name of signer',
    'contract_signature.preview': 'Your signature',
    'contract_signature.confirm': 'I confirm that I am signing this employment agreement on behalf of the employer and approve its contents.',
    'contract_signature.sign_and_send': 'Sign and send',
    'contract_signature.signing': 'Signing and sending...',
    'contract_signature.cancel': 'Cancel',
    'contract_signature.signed_by_employer': 'Signed on behalf of the employer',
    'contract_signature.signature_invalidated': 'Signature invalidated',
    'contract_signature.document_changed': 'The contract was changed after signing – the signature was invalidated. Please sign again.',
    'contract_signature.name_differs_warning': 'The name you entered differs from the name of the logged-in user. Do you want to continue?',
    'contract_signature.typed_hint': 'The signature is typed – write your full name and it will appear as an electronic signature.',
    // Admin dashboard
    'dashboard.title': 'Overview',
    'dashboard.refresh': 'Refresh',
    'dashboard.present_now': 'Present now',
    'dashboard.not_arrived': 'Not arrived',
    'dashboard.sick_today': 'Sick today',
    'dashboard.on_leave': 'On leave / absent',
    'dashboard.pending_requests': 'Pending requests',
    'dashboard.needs_review': 'Needs review',
    'dashboard.today_status': "Today's status",
    'dashboard.action_required': 'Action required',
    'dashboard.next_7_days': 'Next 7 days',
    'dashboard.employee': 'Employee',
    'dashboard.shift': 'Scheduled shift',
    'dashboard.status': 'Status',
    'dashboard.arrival': 'Arrival',
    'dashboard.worked_so_far': 'Worked so far',
    'dashboard.open': 'Open',
    'dashboard.clear_filter': 'Clear filter',
    'dashboard.no_employees': 'No employees in this filter.',
    'dashboard.no_pending': 'No requests awaiting approval.',
    'dashboard.view_all_requests': 'View all requests',
    'dashboard.quick_actions': 'Quick actions',
    'dashboard.register_absence': 'Register absence',
    'dashboard.view_requests': 'View requests',
    'dashboard.open_timesheet': 'Open timesheet',
    'dashboard.open_calendar': 'Open calendar',
    'dashboard.no_absences': 'No absences',
    'dashboard.scheduled_short': 'scheduled',
    'dashboard.expected_at': 'Expected at',
    'dashboard.no_clock_in': 'Not clocked in',
    'dashboard.no_absence_registered': 'No absence registered',
    'dashboard.missing_clock_out': 'Missing clock-out',
    'dashboard.overlapping_entries': 'Overlapping/duplicate entries',
    'dashboard.unanswered_notification': 'Unanswered notification',
    'dashboard.notification_no_answer': 'Response: none',
    'dashboard.mark_resolved': 'Mark resolved',
    'dashboard.see_history': 'See history',
    'dashboard.last_notification': 'Last notification',
    'dashboard.older_cases': 'older cases',
    'dashboard.case_unexplained': 'Unexplained absence',
    'dashboard.resolve_reason_label': 'Reason (required)',
    'dashboard.resolve_reason_placeholder': 'E.g. Old case – resolved manually',
    'dashboard.resolve_dialog_title': 'Mark attendance case resolved',
    'dashboard.resolve_dialog_desc': 'Closes the case without registering an absence or punch. History is preserved and the action is audit-logged.',
    'dashboard.history_title': 'Attendance case history',
    'dashboard.history_cases': 'Attendance cases',
    'dashboard.history_notifications': 'Sent notifications',
    'dashboard.no_history': 'No history',
    'dashboard.resolved_label': 'Resolved',
    'dashboard.unresolved_label': 'Unresolved',
    'dashboard.cancel': 'Cancel',
    'dashboard.status_present': 'Present',
    'dashboard.status_not_arrived': 'Not arrived',
    'dashboard.status_sick': 'Sick',
    'dashboard.status_vacation': 'Vacation',
    'dashboard.status_other_absence': 'Other absence',
    'dashboard.status_pending_absence': 'Request pending',
    'dashboard.status_not_started': 'Shift not started',
    'dashboard.status_finished': 'Clocked out',
    'dashboard.status_off_today': 'Not scheduled today',
    // General
    loading: 'Loading...',
    logout: 'Logout',

    // Navigation
    nav_dashboard: 'Dashboard',
    nav_employees: 'Employees',
    nav_timesheet: 'Timesheet',
    nav_calendar: 'Calendar',
    nav_leave: 'Leave & Sickness',
    nav_users: 'User Management',
    nav_kiosk: 'Kiosk',
    nav_settings: 'Settings',

    // Timesheet
    timesheet_title: 'Timesheet',
    timesheet_new_entry: 'New time entry',
    timesheet_refresh: 'Refresh',
    timesheet_export_excel: 'Download Excel',
    timesheet_filter_employees: 'Filter by employees:',
    timesheet_filter_status: 'Filter by status:',
    timesheet_filter_status_all: 'All',
    timesheet_filter_status_pending: 'Pending',
    timesheet_filter_status_approved: 'Approved',
    timesheet_filter_status_rejected: 'Rejected',
    timesheet_status_pending: 'Pending',
    timesheet_status_approved: 'Approved',
    timesheet_status_rejected: 'Rejected',
    timesheet_approve_selected: 'Approve selected',
    timesheet_approve_single: 'Approve',
    timesheet_selected_count: 'Selected entries',
    timesheet_filter_employees_active_button: 'Active employees',
    timesheet_filter_employees_inactive_button: 'Inactive employees',
    timesheet_filter_employees_all_button: 'All employees',
    timesheet_employee_label: 'Employee:',
    timesheet_employee_option_active: 'Active',
    timesheet_employee_optgroup_active: 'Active employees',
    timesheet_employee_optgroup_inactive: 'Inactive employees',
    timesheet_period_label: 'Period:',
    timesheet_period_from_label: 'From:',
    timesheet_period_to_label: 'To:',
    timesheet_period_clear: 'Clear period',
    timesheet_period_current: 'Current salary period',
    timesheet_period_previous: 'Previous salary period',
    timesheet_field_clock_in_label: 'Clock in',
    timesheet_field_clock_out_label: 'Clock out',
    timesheet_field_total_hours_label: 'Total hours',
    timesheet_field_location_label: 'Location',
    timesheet_in_progress_value: 'Working',
    timesheet_no_location_value: 'None',
    timesheet_show_map: 'Show map',
    timesheet_hide_map: 'Hide map',
    timesheet_dialog_new_title: 'New time entry',
    timesheet_dialog_edit_title: 'Edit time entry',
    timesheet_dialog_employee_label: 'Employee',
    timesheet_dialog_clock_in_label: 'Clock in',
    timesheet_dialog_clock_out_label: 'Clock out',
    timesheet_dialog_clock_out_help_new: 'Leave empty if not clocked out.',
    timesheet_dialog_clock_out_help_edit:
      'Leave empty if not clocked out yet.',

    // Leave / Frí & veikindi
    leave_title: 'Leave & Sickness',
    leave_subtitle: 'Submit and approve leave and sickness requests',
    leave_new_request: 'New request',
    leave_type_label: 'Type',
    leave_from_label: 'From date',
    leave_to_label: 'To date',
    leave_reason_label: 'Reason',
    leave_status_label: 'Status',
    leave_employee_label: 'Employee',
    leave_fetch_error: 'Error fetching requests',
    leave_request_sent: 'Request sent!',
    leave_generic_error: 'An error occurred',
    leave_approved: 'Request approved',
    leave_rejected: 'Request rejected',
    leave_request_updated: 'Request updated',
    leave_request_deleted: 'Request deleted',
    leave_dialog_title: 'New leave or sickness request',
    leave_employee_select_placeholder: 'Select employee',
    leave_type_option_vacation: 'Vacation',
    leave_type_option_sick: 'Sickness',
    leave_type_option_unpaid: 'Unpaid absence',
    attendance_missing_title: 'Attendance not registered',
    attendance_missing_description: 'Your shift was scheduled to start at {time}, but no clock-in or absence has been registered. Please select the option that applies.',
    attendance_missing_sick: "I'm sick",
    attendance_missing_vacation: "I'm on vacation / leave",
    attendance_missing_other: 'Other absence',
    attendance_missing_forgot_clock_in: 'I arrived but forgot to clock in',
    attendance_missing_sick_multi_day: 'Sick for multiple days',
    attendance_missing_sick_end_date: 'Expected end date (optional)',
    attendance_missing_sick_end_date_hint: "Leave empty if you don't know the end date.",
    attendance_missing_explanation_label: 'Short explanation',
    attendance_missing_explanation_placeholder: 'Briefly describe the absence...',
    attendance_missing_arrival_time_label: 'When did you arrive?',
    attendance_missing_submit: 'Submit',
    attendance_missing_back: 'Back',
    attendance_missing_confirmation_sick: 'Your sickness absence has been registered. Your manager has been notified.',
    attendance_missing_confirmation_vacation: 'Your leave request has been submitted and is pending manager approval.',
    attendance_missing_confirmation_other: 'Your absence has been registered and is pending manager review.',
    attendance_missing_correction_requested: 'Your clock-in correction request has been submitted and is pending approval.',
    attendance_missing_already_answered: 'You have already responded to this notification. Thank you!',
    attendance_missing_invalid_link: 'This link is invalid.',
    attendance_missing_expired_link: 'This link has expired. Please contact your manager.',
    attendance_missing_error_generic: 'An error occurred. Please try again or contact your manager.',
    leave_submit_button: 'Submit request',

    // Common buttons
    btn_save: 'Save',
    btn_cancel: 'Cancel',
    btn_delete: 'Delete',
    btn_edit: 'Edit',
  },
};

export function getInitialLanguage() {
  if (typeof window === 'undefined') return 'is';
  const stored = window.localStorage.getItem('lang');
  if (stored === 'is' || stored === 'en') return stored;
  return 'is';
}

export function createTranslator(language) {
  return function t(key) {
    const langTable = translations[language] || translations.is;
    return langTable[key] || translations.is[key] || key;
  };
}

export default translations;
